export enum View {
    LANDING,
    NOTES,
}
